// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  'Action will not be applied for access items that belong to the certifier.':
    'ShowSelfCertificationNote.Default.Label',
  Success: 'CERTS_SUCCESS',
  Clear: 'CERTS_CLEAR',
  'The operation is taking longer than usual. Processing your request in the background.':
    'Certs.bulkAction.info',
  'Resync is in progress. Please retry after some time.': 'Certs.Resync.Info',
  Close: 'CloseLabel',
  Info: 'EXPORT_ALERT_FAILED412_TITLE',
};
